import {I18n} from "react-redux-i18n";

const parkingGraphSearchFields = ({slot, parkingFloor, category, startDate, endDate, startWorkingHours, endWorkingHours}, {floorData, slotData, categoryData}) => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "slot",
                label: I18n.t('parking.search.placeholders.slot'),
                type: "dropdown",
                value: slot?.value,
                data: slotData.map(f => ({
                    label: f.number,
                    value: f.id
                })).sort(function(id, nextId) {
                    return id.label - nextId.label;
                  })
            }, {
                id: "parkingFloor",
                label: I18n.t('parking.search.placeholders.parkingFloor'),
                type: "dropdown",
                value: parkingFloor?.value,
                data: floorData.map(f => ({
                    label: f.name,
                    value: f.id
                }))
            }, {
                id: "category",
                label: I18n.t('parking.search.placeholders.category'),
                type: "dropdown",
                value: category?.value,
                data: categoryData.map(f => ({
                    label: f.id,
                    value: f.name
                }))
            }]
        }, {
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "startDate",
                label: I18n.t('parking.search.labels.startTime'),
                type: "date",
                value: startDate?.value
            },{
                id: "endDate",
                label: I18n.t('parking.search.labels.endTime'),
                type: "date",
                value: endDate?.value
            }]
        }, {
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: 
            [{
                id: "startWorkingHours",
                label: I18n.t('parking.search.labels.startWorkingHours'),
                type: "time",
                value: startWorkingHours?.value
            },{
                id: "endWorkingHours",
                label: I18n.t('parking.search.labels.endWorkingHours'),
                type: "time",
                value: endWorkingHours?.value
            }]
        }]
    }
};

const parkingTableSearchFields = ({slotId, parkingFloor, category, status}, {floorData, slotData, categoryData, statusData}) => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "slotId",
                label: I18n.t('parking.search.placeholders.slot'),
                type: "dropdown",
                value: slotId?.value,
                data: slotData.map(f => ({
                    label: f.number,
                    value: f.id
                })).sort(function(_id, nextId) {
                    return _id.label - nextId.label;
                  })
            }, {
                id: "parkingFloor",
                label: I18n.t('parking.search.placeholders.parkingFloor'),
                type: "dropdown",
                value: parkingFloor?.value,
                data: floorData.map(f => ({
                    label: f.name,
                    value: f.id
                }))
            }, {
                id: "category",
                label: I18n.t('parking.search.placeholders.category'),
                type: "dropdown",
                value: category?.value,
                data: categoryData.map(f => ({
                    label: f.id,
                    value: f.name
                }))
            },{
                id: "status",
                label: I18n.t('parking.search.placeholders.status'),
                type: "dropdown",
                value: status?.value,
                data: statusData.map(f => ({
                    label: f.name,
                    value: f.id
                }))
            }]
        }]
    }
};

export {
    parkingGraphSearchFields,
    parkingTableSearchFields
}